/**
 * Fork of LgyFormInput with USWDS1+2 support
 *
 * @prettier
 * @author Alexander Nagelberg
 */
import React from 'react'

/**
 * Represents a "standard" form submission button set.
 *
 * @author Alex Clary
 *
 * TODO: Maybe add LGYLoadingIcon or other colors to help draw attention to successes or failures.
 * TODO: Maybe change the button language, changing the button text to just "Failed!" can be somewhat unclear.
 *
 * @param {Object} props Properties
 * @param {Function} [props.onSubmitButtonClicked] If you want to prevent the form from submitting and instead execute your own custom function, inject it here
 * @param {boolean} props.pristine True if the form data is the same as its initialized values.
 * @param {boolean} props.submitting True if the form is currently submitting.
 * @param {boolean} props.submitFailed True if the form submission failed for some reason
 * @param {boolean} props.submitSucceeded True if the form submission succeeded.
 * @param {String} [props.error] A generic human-readable error message that doesn't make sense to be associated to a particular form input. These should be generally be expected validation or processing errors.
 * @param {Function} [props.reset] A function to execute if the reset button is clicked. If not provided then the reset button won't be rendered.
 * @param {String} [props.submitLabel] Alternative label text for Submit button
 */
const LgyFormSubmit = ({
  onSubmitButtonClicked,
  pristine,
  submitting,
  percent,
  submitFailed,
  submitSucceeded,
  error,
  reset,
  invalid,
  submitLabel
}) => (
  <div className='lgy-form-submit'>
    <button
      type={onSubmitButtonClicked ? 'button' : 'submit'}
      disabled={pristine || submitting || invalid}
      onClick={onSubmitButtonClicked ? onSubmitButtonClicked : undefined}
      className='usa-button usa-button--primary'
    >
      {submitting
        ? percent
          ? `${percent}% complete`
          : 'Submitting...'
        : submitFailed
        ? 'Submit Again'
        : submitSucceeded
        ? 'Success'
        : submitLabel
        ? submitLabel
        : 'Submit'}
    </button>
    {reset && (
      <button
        type='button'
        className='usa-button-secondary usa-button usa-button--outline'
        disabled={pristine || submitting}
        onClick={reset}
      >
        Reset
      </button>
    )}
    {error && (
      <div>
        <span className='usa-input-error-message' role='alert'>
          {error}
        </span>
      </div>
    )}
  </div>
)

export default LgyFormSubmit
